
import React, { Component } from 'react';
import CalculationHelper from '../components/admin/table_session/helper/CalculationHelper';
import { Bill } from '../Model/Bill';

const tdStyle= {
    // padding: "3px",
    // height: "20px",
}

const style = {
    noBorder: {
        ...tdStyle,
        border: "none"
    },
    topSingle: {
        ...tdStyle,
        border: "none",
        borderTop: "1px solid"
    },
    topDouble: {
        ...tdStyle,
        border: "none",
        borderTop: "2px solid"
    },
    topBottomDouble: {
        ...tdStyle,
        border: "none",
        borderTop: "2px solid",
        borderBottom: "2px solid",
    },
    bottomDouble: {
        ...tdStyle,
        border: "none",
        borderBottom: "2px solid"
    },
    bottomBorder: {
        ...tdStyle,
        border: "none",
        borderBottom: "1px solid"
    },
    floatRight: {
        ...tdStyle,
        textAlign:"right"
        // float: "right"
    },
}
class BillSummaryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    calculateBill = () => {
        let gotTax = this.props.app.state.merchant.tax_no != null
        let scPercent = this.props.app.getMerchantSettingValue('service_charge')
        let extraSCstart = this.props.app.getMerchantSettingValue('extra_service_charge_start')
        let extraSCend = this.props.app.getMerchantSettingValue('extra_service_charge_end')
        let extraSCGetName = this.props.app.getMerchantSettingValue('extra_service_charge_name')
        let extraSCName = extraSCGetName != "" ? extraSCGetName : "Extra Surcharge"
        let extraSCPercent = this.props.app.getMerchantSettingValue('extra_service_charge_value')
        let extraSCValue = (extraSCPercent == null || extraSCPercent == 0) ? 0 : (extraSCPercent / 100.00);
        let serviceCharge = (scPercent == null || scPercent == 0) ? 0 : (scPercent / 100.00);
        let deliveryCharge = parseFloat(this.state.deliveryDetail && this.state.deliveryDetail.deliveryCharge || 0)
        let roundTo = this.props.app.state.merchant.bill_round_to_nearest
        const billDetail = Bill.calculateBillDetailsForOrder({
            orders: this.props.app.state.orders, isHasTax: gotTax, pickupTime: this.props.app.state.table_session.pickup_time, serviceCharge, extraSCstart, extraSCend, extraSCName, extraSCValue, deliveryCharge, roundTo
        })
        return billDetail
    }

    getDeliveryCharge = () => {
        const bill = this.props.bill
        return parseFloat(bill.delivery_charge || 0) - parseFloat(bill.promo_code_delivery_discount || 0)
    }
    getContent() {
        const bill = this.props.bill
        const vHistory = this.props.voucher_history
        const tax = () => {
            const tax = parseFloat(bill.tax || 0)
            if (tax) {
                return (
                    <tr>
                        <td style={style.noBorder}><p style={style.floatRight}>{lang.sst}</p></td>
                        <td style={style.noBorder}><p>:</p></td>
                        <td style={style.noBorder}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(tax).toFixed(2)}</b></td>
                    </tr>
                )
            }
        }
        const extraServiceCharge = () => {
            const extraServiceCharge = parseFloat(bill.extra_service_charge || 0)
            const extraServiceChargeName = bill.extra_service_charge_name != "" ? bill.extra_service_charge_name : "Extra Surcharge"
            if (extraServiceCharge) {
                return (
                    <tr>
                        <td style={style.noBorder}><p style={style.floatRight}>{extraServiceChargeName}</p></td>
                        <td style={style.noBorder}><p>:</p></td>
                        <td style={style.noBorder}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(extraServiceCharge).toFixed(2)}</b></td>
                    </tr>
                )
            }
        }
        const serviceCharge = () => {
            const serviceCharge = parseFloat(bill.service_charge || 0)
            if (serviceCharge) {
                return (
                    <tr>
                        <td style={style.noBorder}><p style={style.floatRight}>{lang.service_charge}</p></td>
                        <td style={style.noBorder}><p>:</p></td>
                        <td style={style.noBorder}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(serviceCharge).toFixed(2)}</b></td>
                    </tr>
                )
            }
        }
        const deliveryCharge = () => {
            const deliveryCharge = this.getDeliveryCharge()
            if (deliveryCharge) {
                return (
                    <tr>
                        <td style={style.noBorder}><p style={style.floatRight}>{lang.delivery_charge}</p></td>
                        <td style={style.noBorder}><p>:</p></td>
                        <td style={style.noBorder}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(deliveryCharge).toFixed(2)}</b></td>
                    </tr>
                )
            }
        }

        const roundingAmount = (this.props.bill.rounding || 0) * 1
        const rounding = () => {
            const absolute = Math.abs(roundingAmount)
            const [sign, className] = roundingAmount >= 0 ?
                ["",""] :
                [" - ", "text-danger"]

            if (absolute) {
                return (
                    <tr>
                        <td style={style.noBorder} className={className}><p style={style.floatRight}>{lang.rounding}</p></td>
                        <td style={style.noBorder} className={className}><p>:</p></td>
                        <td style={style.noBorder} className={className}><b style={style.floatRight}>{sign}{this.props.currencyName}&nbsp; {(absolute).toFixed(2)}</b></td>
                    </tr>
                )
            }
        }
        const subTotal = () => {
            let subTotalValue = CalculationHelper.round2dp(parseFloat(bill.subtotal) + parseFloat(bill.extra_charge || 0))
            return (
                <tr>
                    <td style={style.noBorder}><p style={style.floatRight}>{lang.sub_total}</p></td>
                    <td style={style.noBorder}><p>:</p></td>
                    <td style={getDiscountValue() ? style.noBorder : style.bottomBorder}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {subTotalValue.toFixed(2)}</b></td>
                </tr>
            )
        }

        const getDiscountValue = () => {
            const discount = parseFloat(bill.discount || 0)
            const promoCodeDiscount = parseFloat(bill.promo_code_discount || 0)
            const voucherValue = parseFloat(vHistory && vHistory.voucher_value || 0)
            return discount + promoCodeDiscount + voucherValue
        }

        const discountDetail = () => {
            const totalDiscount = getDiscountValue()
            if (totalDiscount) {
                const className = "text-danger"
                return <tr>
                    <td style={style.noBorder}><p className={className} style={style.floatRight}>{lang.discount}</p></td>
                    <td style={style.noBorder} className={className}><p>:</p></td>
                    <td style={style.bottomDouble}><b><span className={className} style={style.floatRight}>- {this.props.currencyName}&nbsp; {(totalDiscount).toFixed(2)}</span></b></td>
                </tr>
            }
        }

        const total = () => {
            const total = parseFloat(bill.total || 0)
            const deliveryCharge = this.getDeliveryCharge()
            return <tr>
                <td style={style.noBorder}><b style={style.floatRight}>{lang.total}</b></td>
                <td style={style.noBorder}><p>:</p></td>
                <td style={style.topSingle}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(total + deliveryCharge).toFixed(2)}</b></td>
            </tr>
        }

        if (bill.voucher_history_id != null && vHistory != null) {
            const discountHeader = () => {
                let discountHeaderText = vHistory.voucher_desc || lang.try_next_time
                return <div className="voucher-box mb-2">
                    <label className="label label-primary">{lang.lucky_draw_result}</label>
                    <h2>{discountHeaderText}</h2>
                </div>
            }



            // const totalAfterDiscount = () => {
            //     const afterDiscount = bill.total
            //     return <tr>
            //         <td style={style.noBorder}><p style={style.floatRight}>{lang.total_before_tax} :</p></td>
            //         <td style={style.noBorder}><b style={style.floatRight}>RM {(afterDiscount * 1).toFixed(2)}</b></td>
            //     </tr>
            // }

            const total = () => {
                const deliveryCharge = this.getDeliveryCharge()
                const total = bill.total + roundingAmount + deliveryCharge
                return <tr>
                    <td style={style.noBorder}><b style={style.floatRight}>{lang.total}</b></td>
                    <td style={style.noBorder}><p>:</p></td>
                    <td style={style.borderBottom}><b style={style.floatRight}>{this.props.currencyName}&nbsp; {(total * 1).toFixed(2)}</b></td>
                </tr>
            }
            return (
                <div>
                    {discountHeader()}
                    <table className="table billing-table" style={{ margin: "0px auto" }}>
                        <tbody>
                            {subTotal()}
                            {discountDetail(vHistory)}
                            {/* {totalAfterDiscount()} */}
                            {deliveryCharge()}
                            {rounding()}
                            {total()}
                            {!this.props.isAdminView && <tr><td style={{...style.noBorder, textAlign: "center"}} colSpan="3"><p>{lang.pay_counter}</p></td></tr>}
                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <div>
                    <table className="table billing-table" style={{ margin: "25px auto" }}>
                        <tbody>
                            {subTotal()}
                            {discountDetail()}
                            {extraServiceCharge()}
                            {serviceCharge()}
                            {tax()}
                            {deliveryCharge()}
                            {rounding()}
                            {total()}
                            {/* <tr>
                                <td><b>{lang.total} : </b></td>
                                <td><b>RM{(bill.total * 1).toFixed(2)}</b></td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            )
        }
    }
    render() {
        return (
            this.getContent()
        );
    }
}

export default BillSummaryDetail;